import {FC, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {useNavigate, useParams} from "react-router-dom";
import {APIState} from "@buildwitt/shapeshift-identity";
import {IPlaylistEntity, IPlaylistEntityPayload} from "../../../../../types/playlist";
import {AdminPlaylistPageContent} from "./AdminPlaylistPageContent";

interface IProps {}

const useStyles = makeStyles()(() => ({
	adminPlaylistPage: {
	}
}));

const template: IPlaylistEntityPayload = {
	title: "", slug: "", content: ""
}

export const AdminPlaylistPage: FC<IProps> = () => {
	const {playlistId} = useParams();
	const {classes} = useStyles();
	const navigate = useNavigate();
	const entityId = playlistId ? parseInt(playlistId) : undefined;
	const [locale, setLocale] = useState<string>();

	const handleOnSaveResponse = (e: APIState<IPlaylistEntity>): void => {
		if(!e.data)
			return;

		navigate("../" + e.data.id.toString())
		navigate("/admin/playlists/" + e.data.id.toString() + "/edit")
	}

	const handleOnGetResponse = (entityApiResponse: APIState<IPlaylistEntity>): void => {
		if(!entityApiResponse.data || entityApiResponse.isLoading)
			return;

		if(entityApiResponse.statusCode === 404){
			navigate("/admin/playlists")
		}

		if(!entityApiResponse.data)
			return;

		if(entityId && entityApiResponse.data.id !== entityId){
			navigate("/admin/playlists/" + entityApiResponse.data.id.toString() + "/edit?locale=" + entityApiResponse.data.locale)
		}
	}

	const handleOnDeleteResponse = (deleteApiResponse: APIState<IPlaylistEntity>): void => {
		if(!deleteApiResponse.data || deleteApiResponse.isLoading)
			return;

		if(deleteApiResponse.statusCode === 200){
			navigate("/admin/playlists")
		}
	}

	const PlaylistIdParsed = playlistId ? parseInt(playlistId) : undefined

	return (
		<Box className={classes.adminPlaylistPage}>
			<AdminPlaylistPageContent
				playlistId={PlaylistIdParsed}
				onSaveResponse={handleOnSaveResponse}
				onDeleteResponse={handleOnDeleteResponse}
				onGetResponse={handleOnGetResponse}
				onLocaleChange={e => setLocale(e)}
				locale={locale}
				template={template}
			/>
		</Box>
	);
}